import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=47d45642&scoped=true&"
import script from "./AccountCenter.vue?vue&type=script&lang=js&"
export * from "./AccountCenter.vue?vue&type=script&lang=js&"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=47d45642&lang=less&scoped=true&"
import style1 from "./AccountCenter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d45642",
  null
  
)

export default component.exports